// Import centralized date formatter
import { formatDate } from '../../utils/dateFormatter';

export const convertDateToDisplayFormat = formatDate;

export const convertDateFormat = (inputDate) => {
    if (!inputDate) return "";

    // Convert ISO string to Date object
    const date = new Date(inputDate);

    if (isNaN(date.getTime())) return "";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};


export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const generateSubjectId = (siteCode, subjects) => {
    if (!siteCode) return '';
    const siteSubjects = subjects.filter(s => String(s.subjectId).startsWith(siteCode));
    const lastNumber = siteSubjects.length;
    return `${siteCode}-${String(lastNumber + 1).padStart(3, '0')}`;
};